/**
 * "Sektörde 10. Yıl" damgası — dönen halka yazı + ortada 10.
 * boyut: px; koyu: siyah zeminli (footer) varyant.
 */
export default function OnuncuYilRozeti({ boyut = 96, koyu = false, className = "" }: { boyut?: number; koyu?: boolean; className?: string }) {
  const id = koyu ? "dj10-koyu" : "dj10-acik";
  const zemin = koyu ? "#0a0a0a" : "#9EFF00";
  const metin = koyu ? "#9EFF00" : "#000";
  return (
    <span className={`relative inline-flex items-center justify-center shrink-0 ${className}`} style={{ width: boyut, height: boyut }} aria-label="Sektörde 10. yılımız">
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full animate-spin [animation-duration:22s]" aria-hidden="true">
        <defs><path id={id} d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" /></defs>
        <circle cx="50" cy="50" r="48" fill={zemin} stroke={koyu ? "#9EFF00" : "#000"} strokeWidth="3" />
        <text fill={metin} fontSize="9.2" fontWeight="800" fontFamily="ui-monospace, monospace" letterSpacing="1.4">
          <textPath href={`#${id}`}>SEKTÖRDE 10. YIL • 2016'DAN BERİ DİJİPO • E-TİCARET REKLAM AJANSI •</textPath>
        </text>
      </svg>
      <span className="relative flex flex-col items-center leading-none" style={{ color: metin }}>
        <span className="font-black" style={{ fontSize: boyut * 0.34 }}>10</span>
        <span className="font-mono font-bold tracking-widest" style={{ fontSize: boyut * 0.085 }}>YIL</span>
      </span>
    </span>
  );
}
